import { logUnusedKeys } from '@/model/Utils';

export default function (other) {
  other = other || {};
  let result = {
    range: {
      from: other.range?.from || null,
      until: other.range?.until || null,
    },
    orgIds: other.orgIds || [],
    buIds: other.buIds || [],
    userIds: other.userIds || [],
    types: other.types || [],
    realOnly: other.realOnly !== false,
    // TXF: true takes the taxes money OUT of the deposit/net KPIs.
    excludeTxf: other.excludeTxf === true,
    // Approval-time window: the dateRange widget writes {start, end} datetimes
    // into filter.operationTime — the backend wants a plain {from, until} DateRange.
    operationRange: other.operationTime && (other.operationTime.start || other.operationTime.end)
      ? {
        from: other.operationTime.start ? String(other.operationTime.start).slice(0, 10) : null,
        until: other.operationTime.end ? String(other.operationTime.end).slice(0, 10) : null,
      }
      : null,
  };
  logUnusedKeys('MonetaryDashboardSearchRequest', result, other);
  return result;
}
